module.exports = __webpack_public_path__ + "img/shuicao2.80ed1b2f.gif";